export const environment = {
  production: true,
  apiUrl: 'https://api-ml-v4.eyezilla.ai/api',
  grafanaUrl: 'https://api-ml-v4.eyezilla.ai/grafana',
  grafanaLiveScreenUrl: 'https://api-ml-v4.eyezilla.ai/grafana-v6',
};
